


import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    computed: {
        ...mapGetters(["config", "formSection"])
    }
})
export default class EditButtonComponent extends Vue {
    @Prop() type!: string;
    @Prop() saveActive!: boolean;

    public toggleSection(status: boolean): void {
        this.$store.dispatch('formSectionOpen', {type: this.type, status: status});
    }

    public saveSection(): void {
        this.$emit('save');
    }
}
